// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let _;
let RivalIQ;
if (typeof window === 'undefined') {

    _ = require('lodash');
    RivalIQ = {
        enums: {}
    };

    module.exports = RivalIQ.enums;

} else {
    _ = window._;
    RivalIQ = window.RivalIQ;
    RivalIQ.module('enums', function () {});
}

(function (enums) {
    'use strict';

    // TODO move this, and descriptions, into its own file
    const timeAnalysisMode = enums.timeAnalysisMode = {
        MAIN_PERIOD: 0,
        COMPARE_PERIOD: 1,
        DELTA_ABSOLUTE: 3,
        DELTA_RELATIVE: 4,
        DAILY_VALUES: 5,
        WEEKLY_VALUES: 6,
        MONTHLY_VALUES: 7
    };

    timeAnalysisMode.descriptions = {};
    let timeAnalysisOrderingCount = 0;

    /**
     * Creates a time analysis mode description.
     * @param mode
     * @param name
     * @param description
     * @param supportsSecondaryMetric
     */
    function createTimeAnalysisModeDescription(mode, name, description, supportsSecondaryMetric) {
        timeAnalysisMode.descriptions[mode] = {
            id: mode,
            orderId: timeAnalysisOrderingCount++,
            name: name,
            description: description,
            supportsSecondaryMetric: (supportsSecondaryMetric !== false)
        };
    }

    createTimeAnalysisModeDescription(timeAnalysisMode.MAIN_PERIOD, 'Selected Period Values', 'The values for the selected period.');
    createTimeAnalysisModeDescription(timeAnalysisMode.COMPARE_PERIOD, 'Previous Period Values', 'The values for the compare period.');
    createTimeAnalysisModeDescription(timeAnalysisMode.DELTA_ABSOLUTE, 'Change vs. Compare Period', 'The absolute change since the previous period.');
    createTimeAnalysisModeDescription(timeAnalysisMode.DELTA_RELATIVE, '% Change vs. Compare Period', 'The relative change since the previous period.');
    createTimeAnalysisModeDescription(timeAnalysisMode.DAILY_VALUES, 'Daily Values', 'The historical values of the metric, by day.', false);
    createTimeAnalysisModeDescription(timeAnalysisMode.WEEKLY_VALUES, 'Weekly Values', 'The historical values for this metric, grouped by week.', false);
    createTimeAnalysisModeDescription(timeAnalysisMode.MONTHLY_VALUES, 'Monthly Values', 'The historical values for this metric, grouped by month.', false);

    enums.sources = {
        TWITTER: 0,
        FACEBOOK: 1,
        LINKEDIN: 2,
        // 3 is defunct
        YOUTUBE: 4,
        INSTAGRAM: 5,
        // 6 is defunct
        WEB: 7,
        RIVALIQ: 8,
        // 9 is defunct
        CROSS_CHANNEL: 10,
        FACEBOOK_INSIGHTS: 11,
        // 12 is defunct
        // 13 is defunct
        // 14 is defunct
        FACEBOOK_BOOSTED_POST_INSIGHTS: 15,
        FACEBOOK_ADS: 16,
        // 17 is defunct
        INSTAGRAM_INSIGHTS: 18,
        TWITTER_INSIGHTS: 19,
        TIKTOK: 20,
        TIKTOK_INSIGHTS: 21,
        CROSS_CHANNEL_INSIGHTS: 22 // while CROSS_CHANNEL is for public data only, CROSS_CHANNEL_INSIGHTS is for both public and private data
        // 30..31 reserved for enums.pseudoSources
        // >= 32 reserved for enums.sourceMask
    };

    // Not actual sources, these are only used for repair scripts, reindexing, etc.
    //
    // Do NOT include in enums.sources or enums.sourceMask!
    //
    // These count down from 31 (just below enums.sourceMask.TWITTER) so that the
    // enums.sources values can continue increasing without collision (for a while).
    enums.pseudoSources = {
        INSTAGRAM_STORIES: 31,
        FACEBOOK_REELS: 30
    };

    // NOTE start above enums.sources, so we can tell from the value which is which
    // NOTE bitwise operators only work up to 32 bits
    const sourceMask = enums.sourceMask = {
        TWITTER: 0x20, // 32
        FACEBOOK: 0x40, // 64
        LINKEDIN: 0x80, // 128
        // 0x100 aka 256 is defunct
        YOUTUBE: 0x200, // 512
        INSTAGRAM: 0x400, // 1024
        // 0x800 aka 2048 is defunct
        // 0x1000 aka 4096 is defunct
        WEB: 0x2000, // 8192
        // 0x4000 aka 16384 is defunct
        FACEBOOK_INSIGHTS: 0x8000, // 32768
        // 0x10000 aka 65536 is defunct
        FACEBOOK_BOOSTED_POST_INSIGHTS: 0x20000, // 131072
        // 0x40000 aka 262144 is defunct
        CROSS_CHANNEL: 0x80000, // 524288
        FACEBOOK_ADS: 0x100000, // 1048576
        // 0x200000 aka 2097152 is defunct
        INSTAGRAM_INSIGHTS: 0x400000, // 4194304
        TWITTER_INSIGHTS: 0x800000, // 8388608
        TIKTOK: 0x1000000, // 16777216
        TIKTOK_INSIGHTS: 0x2000000, // 33554432,
        CROSS_CHANNEL_INSIGHTS: 0x4000000 // 67108864
        // NOTE - adding a new source here will not automatically add it to any
        // plan's supported_sources or to the default landscape active_sources
    };

    sourceMask.ALL = _.sum(_.values(enums.sourceMask));

    // NOTE all defunct mask values should be added here, so that they will be filtered out
    sourceMask.DEFUNCT = 0x100 + 0x800 + 0x1000 + 0x4000 + 0x10000 + 0x40000 + 0x200000;

    enums.channels = {
        TWITTER: 'twitter',
        FACEBOOK: 'facebook',
        LINKEDIN: 'linkedin',
        YOUTUBE: 'youtube',
        INSTAGRAM: 'instagram',
        WEB: 'domain',
        CROSS_CHANNEL: undefined,
        CROSS_CHANNEL_INSIGHTS: 'CROSS_CHANNEL_INSIGHTS',
        RIVALIQ: 'rivaliq',
        TIKTOK: 'tiktok'
    };

    enums.dataType = {
        STRING: 0,
        INTEGER: 1,
        NUMERIC: 2,
        ABSOLUTE_PERCENT: 3,
        DURATION_SECONDS: 4,
        DATE: 5,
        CURRENCY: 6,
        DURATION_MILLIS: 7,
        BOOLEAN: 8,
        OBJECT: 9
    };

    enums.metricType = {
        VOLUME: 0,
        TOTAL: 1,
        TEXT: 2,
        STRING: 3
    };

    enums.category = {
        POSITIONING: 0,
        REACH: 1,
        ACTIVITY: 2,
        ENGAGEMENT: 3
    };

    enums.collection = {
        ACTIVITY: 0x1,
        AUDIENCE: 0x2,
        REACH: 0x4,
        ENGAGEMENT: 0x8,
        ENGAGEMENT_DETAILS: 0x10,
        CONSUMPTIONS: 0x20,
        ORGANIC: 0x40,
        ADWORDS: 0x100,
        GENERAL: 0x200,
        STORY_ENGAGEMENTS: 0x400,
        IMPRESSIONS: 0x800,
        VIDEO_VIEWS_DETAILS: 0x1000,
        PRESENCE_INTERACTIONS: 0x2000,
        REEL_DETAILS: 0x4000,
        REELS_AND_VIDEOS: 0x8000
    };

    enums.metricValueType = {
        SUM: 0x1,
        AVERAGE: 0x2
    };

    enums.valueType = {
        CURRENT: 'period2',
        PREVIOUS: 'period1',
        DELTA: 'deltaAbsolute',
        DELTA_REL: 'deltaRelative',
        DAILY: 'dailyValues',
        PRESENCE: 'presence'
    };

    enums.strings = {
        EMPTY_TEXT: '[ empty ]',
        NOT_ON_CHANNEL: '[ not on channel ]',
        MISSING: '--'
    };

    enums.reachType = {
        TOTAL: 'total',
        ORGANIC: 'organic',
        PAID: 'paid',
        VIRAL: 'viral',
        NONVIRAL: 'nonviral'
    };

    // The sets of sources that are hideable as a group
    enums.hideableSource = {
        FACEBOOK: 'facebook',
        INSTAGRAM: 'instagram',
        TWITTER: 'twitter',
        YOUTUBE: 'youtube',
        LINKEDIN: 'linkedin',
        WEB: 'web',
        TIKTOK: 'tiktok'
    };

    enums.incompleteDataType = {
        CROSS_CHANNEL_HISTORICAL: 0,
        CROSS_CHANNEL_AGGREGATE: 1,
        CHANNEL_AGGREGATE: 2,
        CHANNEL_HISTORICAL: 3,
        NOT_ENOUGH_DATA_IN_PERIOD: 4,
        // id 5 is defunct
        DATA_IN_FLIGHT: 6,
        PROTECTED_DATA: 7,
        NO_ACTIVE_RECORDS: 8,
        NOT_ENOUGH_HISTORY: 9,
        NO_PRIVATE_ACCESS: 10
    };

    /**
     * REFACTOR we should keep logic out of this file
     * Creates a private data company filter.
     * @param source The source to check for private data.
     */
    function createPrivateDataCompanyFilter(source) {

        return function (presencePeriodSummary) {

            const details = enums.sourceDetails[source];

            return presencePeriodSummary.reduce(function (memo, company) {

                const periodSummary = (company.get ? company.get('periodSummary') : company.periodSummary);
                const trend = _.head(periodSummary[details.trendKey]);
                return (trend ? memo.concat([company.id]) : memo);
            }, []);
        };
    }

    /**
     * @property {string}   name                    - The name of the source for display.
     * @property {string}   channel                 - The name of the channel (typically used for posts).
     * @property {string}   channelPrefix           - The prefix for database tables that this channel uses.
     * @property {function} companyFilter           - An optional filtering function to elide companies that do not have access to source data.
     * @property {boolean}  discoverable            - An optional boolean indicating whether this source can be discovered via channel finder.
     * @property {boolean}  privateData             - An optional boolean indicating this source is private data.
     * @property {boolean}  dontShowInUi            - An optional boolean indicating whether or not this source can be displayed (typically via My Charts).
     * @property {object[]} engagementTypes         - An optional array of configuration objects indicating types of engagement for this source.
     * @property {string}   fontIcon                - The font icon to use for display.
     * @property {string}   squareFontIcon          - The font icon to use for display when you need a square icon. In many cases, this is just the fontIcon, but it's overwritten in cases where the normal fontIcon is not a good square.
     * @property {string}   iconUrl                 - An optional path to an image to be use for display.
     * @property {string}   identityType            - An optional property name to use when linking to a profile (such as 'handle' or 'native_id').
     * @property {string[]} identityValueFields     - An optional list of property names required to create a presence record.
     * @property {string}   group                   - An optional group name to be used for data availability calculation in company data (e.g., none, web, social).
     * @property {string}   countTowardsDataFreshness - Optional property; if true, include this source in data freshness calculations.
     * @property {string}   hideableSource          - An optional hideableSource used when showing hiding sources
     * @property {boolean}  hideable                - An optional boolean that defaults to false indicating whether or not this source can be hidden in the UI by user action
     * @property {boolean}  multiOauthToken         - An optional boolean that defaults to false indicating whether this source supports multiple tokens for this channel for a single account user.
     * @property {boolean}  normalizable            - An optional boolean that defaults to false indicating whether or not this source can be normalized for time periods containing periods of differing duration.
     * @property {string}   oauthKey                - An optional OAuth key for handling client-side authorization prompting.
     * @property {string}   channelWallImage        - An optional path to an image to use within the channel wall view.
     * @property {string[]} palette                 - An optional array of CSS class names that provide branding colors for the source.
     * @property {string}   postName                - An optional name of posts for this source.
     * @property {string}   profileUrl              - An optional URL that can be used to navigate to a presence of this source.
     * @property {string}   handlePrefix            - An optional prefix to display when showing the handle name.
     * @property {string}   reachName               - An optional name for the reach, or audience of this source.
     * @property {string}   searchUrl               - An optional URL that can be used to search for presences of this source.
     * @property {number[]} subSources              - An optional array of sources that this source is comprised of, indicating this is likely a meta-source.
     * @property {string}   trendKey                - An optional key indicating where in the period summary this sources data lives.
     * @property {object[]} validContentSortOrders  - An optional array of configuration objects indicating how content from this source can be sorted.
     */
    enums.sourceDetails = {};

    enums.sourceDetails[enums.sources.CROSS_CHANNEL] = enums.sourceDetails[sourceMask.CROSS_CHANNEL] = {
        name: 'Cross-Channel',
        channel: 'cross_channel',
        source: enums.sources.CROSS_CHANNEL,
        sourceMask: enums.sourceMask.CROSS_CHANNEL,
        fontIcon: 'fa-random',
        squareFontIcon: 'fa-random',
        iconSvg: '/images/channel-cross-channel.svg',
        reachName: 'Followers',
        postName: 'post',
        trendKey: 'metaTrends',
        sortIndex: 0,
        supportsNotEnoughHistory: true,
        validContentSortOrders: [
            {
                name: 'engagement_rate',
                displayName: 'Engagement Rate'
            },
            {
                name: 'engagement_total',
                displayName: 'Engagement Total'
            },
            {
                name: 'applause',
                displayName: 'Acknowledgement'
            },
            {
                name: 'conversation',
                displayName: 'Conversation'
            },
            {
                name: 'amplification',
                displayName: 'Amplification'
            },
            {
                name: 'published_at',
                displayName: 'Date',
                skipAverage: true
            },
            {
                name: 'estimated_impressions',
                displayName: 'Estimated Impressions'
            },
            {
                name: 'engagement_rate_by_estimated_impression',
                displayName: 'Engagement Rate by Estimated Impression',
                skipAverage: true // NOTE no db column for this on this channel, so don't try to calculate over it
            }
        ],
        engagementTypeMappings: [],
        engagementTypes: [
            'applause',
            'conversation',
            'amplification'
        ],
        subSources: [
            enums.sources.FACEBOOK,
            enums.sources.INSTAGRAM,
            enums.sources.TWITTER,
            enums.sources.YOUTUBE,
            enums.sources.TIKTOK
        ]
    };

    enums.sourceDetails[enums.sources.TWITTER] = enums.sourceDetails[sourceMask.TWITTER] = {
        iconUrl: '/images/icon-twitter.png',
        fontIcon: 'fa-twitter',
        squareFontIcon: 'fa-twitter-square',
        iconSvg: '/images/channel-twitter.svg',
        name: 'Twitter',
        source: enums.sources.TWITTER,
        sourceMask: enums.sourceMask.TWITTER,
        channel: enums.channels.TWITTER,
        channelPrefix: 'twitter',
        oauthKey: 'twitter',
        channelWallImage: '/images/twitter-auth.svg',
        trendKey: 'twitterTrends',
        searchUrl: 'https://twitter.com/#!/search/users/',
        profileUrl: 'https://twitter.com/',
        handlePrefix: '@',
        identityType: 'handle',
        identityValueFields: ['native_id', 'handle'],
        reachName: 'Followers',
        postName: 'tweet',
        engagementTypeNames: {
            conversation: 'replies',
            amplification: 'retweets'
        },
        group: 'social',
        countTowardsDataFreshness: true,
        supportsNotEnoughHistory: true,
        hideableSource: enums.hideableSource.TWITTER,
        discoverable: true,
        hideable: true,
        indexable: true,
        oauthTokenTypeId: 2,
        engagementTypeMappings: [
            {
                name: 'actual_favorites',
                displayName: 'Likes'
            },
            {
                name: 'actual_replies',
                displayName: 'Replies'
            },
            {
                name: 'actual_retweets',
                displayName: 'Retweets'
            }
        ],
        engagementTypes: [
            'applause',
            'amplification',
            'conversation'
        ],
        sortIndex: 3,
        validContentSortOrders: [
            {
                name: 'engagement_rate',
                displayName: 'Engagement Rate'
            },
            {
                name: 'engagement_total',
                displayName: 'Engagement Total'
            },
            {
                name: 'published_at',
                displayName: 'Date',
                skipAverage: true
            },
            {
                name: 'actual_retweets',
                displayName: 'Retweets'
            },
            {
                name: 'actual_replies',
                displayName: 'Replies'
            },
            {
                name: 'actual_favorites',
                displayName: 'Likes'
            },
            {
                name: 'conversation',
                displayName: 'Conversation',
                filter: true
            },
            {
                name: 'applause',
                displayName: 'Likes',
                filter: true
            },
            {
                name: 'amplification',
                displayName: 'Retweets',
                filter: true
            },
            {
                name: 'estimated_impressions',
                displayName: 'Estimated Impressions'
            },
            {
                name: 'engagement_rate_by_estimated_impression',
                displayName: 'Engagement Rate by Estimated Impression',
                skipAverage: true // NOTE no db column for this on this channel, so don't try to calculate over it
            }
        ],
        palette: [
            'x-twitter',
            'x-twitter-secondary',
            'x-twitter-tertiary'
        ],
        socialPostsProps: ['tweetType'],
        lowResImgSuffix: '_normal',
        multiOauthToken: true,
        uniqueKeyPart: 'user_id',
        oauthRedirectParams: 'newToken=true'
    };

    enums.sourceDetails[enums.sources.TWITTER_INSIGHTS] = enums.sourceDetails[sourceMask.TWITTER_INSIGHTS] = _.defaults({
        discoverable: false,
        hideable: false,
        privateData: true,
        indexable: false,
        credentialsRequired: true,
        name: 'Twitter Analytics',
        iconSvg: '/images/channel-twitter-lock.svg',
        companyFilter: createPrivateDataCompanyFilter(enums.sources.TWITTER_INSIGHTS),
        source: enums.sources.TWITTER_INSIGHTS,
        sourceMask: enums.sourceMask.TWITTER_INSIGHTS,
        oauthTokenTypeId: 2,
        oauthKey: 'twitter',
        trendKey: 'twitterInsightsTrends',
        supportsNotEnoughHistory: true
    }, enums.sourceDetails[enums.sources.TWITTER]);

    enums.sourceDetails[enums.sources.FACEBOOK] = enums.sourceDetails[sourceMask.FACEBOOK] = {
        iconUrl: '/images/icon-facebook.png',
        fontIcon: 'fa-facebook',
        squareFontIcon: 'fa-facebook-square',
        iconSvg: '/images/channel-facebook.svg',
        name: 'Facebook',
        source: enums.sources.FACEBOOK,
        sourceMask: enums.sourceMask.FACEBOOK,
        channel: enums.channels.FACEBOOK,
        channelPrefix: 'facebook',
        oauthKey: 'facebook',
        oauthTokenTypeId: 1,
        trendKey: 'facebookTrends',
        searchUrl: 'https://www.facebook.com/search/results.php?q=',
        profileUrl: 'https://facebook.com/',
        channelWallImage: '/images/facebook-insights-auth.svg',
        identityType: 'native_id',
        identityValueFields: ['native_id', 'handle'],
        reachName: 'Page Likes',
        group: 'social',
        countTowardsDataFreshness: true,
        hideableSource: enums.hideableSource.FACEBOOK,
        discoverable: true,
        hideable: true,
        indexable: true,
        supportsNotEnoughHistory: true,
        engagementTypeMappings: [
            {
                name: 'reactions',
                displayName: 'Reactions'
            },
            {
                name: 'comments',
                displayName: 'Comments'
            },
            {
                name: 'shares',
                displayName: 'Shares'
            }
        ],
        engagementTypes: [
            'applause',
            'conversation',
            'amplification'
        ],
        postName: 'post',
        engagementTypeNames: {
            conversation: 'comments',
            amplification: 'shares'
        },
        sortIndex: 1,
        validContentSortOrders: [
            {
                name: 'engagement_rate',
                displayName: 'Engagement Rate'
            },
            {
                name: 'engagement_total',
                displayName: 'Engagement Total'
            },
            {
                name: 'published_at',
                displayName: 'Date',
                skipAverage: true
            },
            {
                name: 'reactions',
                displayName: 'Reactions'
            },
            {
                name: 'likes',
                displayName: 'Likes'
            },
            {
                name: 'loves',
                displayName: 'Loves'
            },
            {
                name: 'hahas',
                displayName: 'Hahas'
            },
            {
                name: 'wows',
                displayName: 'Wows'
            },
            {
                name: 'sads',
                displayName: 'Sads'
            },
            {
                name: 'angrys',
                displayName: 'Angrys'
            },
            {
                name: 'comments',
                displayName: 'Comments'
            },
            {
                name: 'shares',
                displayName: 'Shares'
            },
            {
                name: 'applause',
                displayName: 'Reactions',
                filter: true
            },
            {
                name: 'conversation',
                displayName: 'Comments',
                filter: true
            },
            {
                name: 'amplification',
                displayName: 'Shares',
                filter: true
            },
            {
                name: 'promoted_likelyhood',
                displayName: 'Likely Boosted',
                filter: true
            },
            {
                name: 'estimated_impressions',
                displayName: 'Estimated Impressions'
            },
            {
                name: 'engagement_rate_by_estimated_impression',
                displayName: 'Engagement Rate by Estimated Impression',
                skipAverage: true // NOTE no db column for this on this channel, so don't try to calculate over it
            }
        ],
        palette: [
            'x-facebook',
            'x-facebook-secondary',
            'x-facebook-tertiary',
            'x-facebook-fourth',
            'x-facebook-fifth',
            'x-facebook-sixth'
        ],
        socialPostsProps: ['promotedPosts']
    };

    enums.sourceDetails[enums.sources.FACEBOOK_INSIGHTS] = enums.sourceDetails[sourceMask.FACEBOOK_INSIGHTS] = _.defaults({
        discoverable: false,
        hideable: false,
        privateData: true,
        indexable: false,
        credentialsRequired: true,
        name: 'Facebook Insights',
        iconSvg: '/images/channel-facebook-lock.svg',
        companyFilter: createPrivateDataCompanyFilter(enums.sources.FACEBOOK_INSIGHTS),
        source: enums.sources.FACEBOOK_INSIGHTS,
        sourceMask: enums.sourceMask.FACEBOOK_INSIGHTS,
        oauthTokenTypeId: 1,
        trendKey: 'facebookInsightsTrends',
        supportsNotEnoughHistory: true
    }, enums.sourceDetails[enums.sources.FACEBOOK]);

    enums.sourceDetails[enums.sources.FACEBOOK_BOOSTED_POST_INSIGHTS] = enums.sourceDetails[sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS] = _.defaults({
        discoverable: false,
        hideable: false,
        privateData: true,
        indexable: false,
        credentialsRequired: true,
        name: 'Facebook Boosted Post Insights',
        source: enums.sources.FACEBOOK_BOOSTED_POST_INSIGHTS,
        sourceMask: enums.sourceMask.FACEBOOK_BOOSTED_POST_INSIGHTS,
        oauthTokenTypeId: 1,
        dontShowInUi: true, // Rolled into FB Insights in the custom chart creator
        trendKey: 'facebookBoostedPostTrends', // NOTE not used but if not overwritten can clobber facebookTrends,
        supportsNotEnoughHistory: false
    }, enums.sourceDetails[enums.sources.FACEBOOK]);

    enums.sourceDetails[enums.sources.FACEBOOK_ADS] = enums.sourceDetails[sourceMask.FACEBOOK_ADS] = _.defaults({
        fontIconBadge: 'AD',
        discoverable: false,
        hideable: false,
        privateData: true,
        indexable: false,
        credentialsRequired: true,
        name: 'Facebook Ads',
        iconSvg: '/images/channel-facebook-lock.svg',
        source: enums.sources.FACEBOOK_ADS,
        sourceMask: enums.sourceMask.FACEBOOK_ADS,
        oauthTokenTypeId: 1,
        dontShowInUi: true, // Rolled into FB Insights in the custom chart creator
        trendKey: 'facebookAdsTrends' // NOTE not used but if not overwritten can clobber facebookTrends
    }, enums.sourceDetails[enums.sources.FACEBOOK]);

    enums.sourceDetails[enums.sources.LINKEDIN] = enums.sourceDetails[sourceMask.LINKEDIN] = {
        iconUrl: '/images/linked_in_35px.png',
        fontIcon: 'fa-linkedin',
        squareFontIcon: 'fa-linkedin-square',
        iconSvg: '/images/channel-linkedin-lock.svg',
        name: 'LinkedIn',
        source: enums.sources.LINKEDIN,
        sourceMask: enums.sourceMask.LINKEDIN,
        channel: enums.channels.LINKEDIN,
        channelPrefix: 'linked_in',
        trendKey: 'linkedInTrends',
        oauthKey: 'linkedIn',
        searchUrl: 'https://www.linkedin.com/csearch/results?type=companies&keywords=',
        channelWallImage: '/images/linkedin-insights-auth.svg',
        profileUrl: 'https://www.linkedin.com/company/',
        identityType: 'native_id',
        identityValueFields: ['native_id', 'handle'],
        reachName: 'Followers',
        group: 'none',
        hideableSource: enums.hideableSource.LINKEDIN,
        discoverable: false,
        hideable: true,
        privateData: true,
        credentialsRequired: true,
        companyFilter: createPrivateDataCompanyFilter(enums.sources.LINKEDIN),
        sortIndex: 5,
        oauthTokenTypeId: 3,
        engagementTypeMappings: [
            {
                name: 'clicks',
                displayName: 'Clicks'
            },
            {
                name: 'likes',
                displayName: 'Likes'
            },
            {
                name: 'comments',
                displayName: 'Comments'
            },
            {
                name: 'shares',
                displayName: 'Shares'
            }
        ],
        engagementTypes: [
            'applause',
            'conversation',
            'amplification',
            'action'
        ],
        postName: 'update',
        validContentSortOrders: [
            {
                name: 'engagement_rate',
                displayName: 'Engagement Rate'
            },
            {
                name: 'engagement_total',
                displayName: 'Engagement Total'
            },
            {
                name: 'published_at',
                displayName: 'Date',
                skipAverage: true
            },
            {
                name: 'likes',
                displayName: 'Likes'
            },
            {
                name: 'comments',
                displayName: 'Comments'
            },
            {
                name: 'applause',
                displayName: 'Likes',
                filter: true
            },
            {
                name: 'conversation',
                displayName: 'Comments',
                filter: true
            },
            {
                name: 'amplification',
                displayName: 'Shares',
                filter: true
            }
        ],
        palette: [
            'x-linked-in',
            'x-linked-in-secondary',
            'x-linked-in-tertiary'
        ]
    };

    enums.sourceDetails[enums.sources.YOUTUBE] = enums.sourceDetails[sourceMask.YOUTUBE] = {
        iconUrl: '/images/icon-youtube.png',
        fontIcon: 'fa-youtube-play',
        squareFontIcon: 'fa-youtube-play',
        iconSvg: '/images/channel-youtube.svg',
        name: 'YouTube',
        source: enums.sources.YOUTUBE,
        sourceMask: enums.sourceMask.YOUTUBE,
        channel: enums.channels.YOUTUBE,
        channelPrefix: 'you_tube',
        channelWallImage: '/images/youtube-auth.svg',
        trendKey: 'youTubeTrends',
        searchUrl: 'https://www.youtube.com/channels?q=',
        profileUrl: 'https://www.youtube.com/channel/',
        identityType: 'native_id',
        identityValueFields: ['native_id', 'playlist_id', 'channel_created_at'],
        reachName: 'Subscribers',
        group: 'social',
        hideableSource: enums.hideableSource.YOUTUBE,
        discoverable: true,
        hideable: true,
        indexable: true,
        supportsNotEnoughHistory: true,
        engagementTypeMappings: [
            {
                name: 'views',
                displayName: 'Views'
            },
            {
                name: 'likes',
                displayName: 'Likes'
            },
            {
                name: 'comments',
                displayName: 'Comments'
            }
        ],
        engagementTypes: [
            'applause',
            'conversation'
        ],
        properties: [
            'views'
        ],
        postName: 'post',
        sortIndex: 4,
        validContentSortOrders: [
            {
                name: 'engagement_rate',
                displayName: 'Engagement Rate'
            },
            {
                name: 'engagement_total',
                displayName: 'Engagement Total'
            },
            {
                name: 'published_at',
                displayName: 'Date',
                skipAverage: true
            },
            {
                name: 'views',
                displayName: 'Views'
            },
            {
                name: 'likes',
                displayName: 'Likes'
            },
            {
                name: 'comments',
                displayName: 'Comments'
            },
            {
                name: 'applause',
                displayName: 'Likes',
                filter: true
            },
            {
                name: 'conversation',
                displayName: 'Comments',
                filter: true
            },
            {
                name: 'amplification',
                displayName: 'Shares',
                filter: true
            },
            {
                name: 'estimated_impressions',
                displayName: 'Estimated Impressions',
                skipAverage: true // NOTE no db column for this on this channel, so don't try to calculate over it; see #33520
            },
            {
                name: 'engagement_rate_by_estimated_impression',
                displayName: 'Engagement Rate by Estimated Impression',
                skipAverage: true // NOTE no db column for this on this channel, so don't try to calculate over it
            }
        ],
        palette: [
            'x-youtube',
            'x-youtube-secondary',
            'x-youtube-tertiary'
        ]
    };

    enums.sourceDetails[enums.sources.INSTAGRAM] = enums.sourceDetails[sourceMask.INSTAGRAM] = {
        iconUrl: '/images/icon-instagram.png',
        fontIcon: 'fa-instagram',
        squareFontIcon: 'fa-instagram',
        iconSvg: '/images/channel-instagram.svg',
        name: 'Instagram',
        source: enums.sources.INSTAGRAM,
        sourceMask: enums.sourceMask.INSTAGRAM,
        channel: enums.channels.INSTAGRAM,
        channelPrefix: 'instagram',
        oauthKey: 'instagram',
        channelWallImage: '/images/instagram-auth.svg',
        trendKey: 'instagramTrends',
        searchUrl: 'https://pro.iconosquare.com/search?generalsearch=',
        profileUrl: 'https://instagram.com/',
        handlePrefix: '@',
        identityType: 'handle',
        identityValueFields: ['handle', 'instagram_business_account_id'],
        reachName: 'Followers',
        supportsNotEnoughHistory: true,
        oauthNativeIdField: 'instagram_business_account_id',
        engagementTypeMappings: [
            {
                name: 'likes',
                displayName: 'Likes'
            },
            {
                name: 'comments',
                displayName: 'Comments'
            }
        ],
        engagementTypes: [
            'applause',
            'conversation'
        ],
        postName: 'post',
        engagementTypeNames: {
            conversation: 'comments'
        },
        group: 'social',
        countTowardsDataFreshness: true,
        hideableSource: enums.hideableSource.INSTAGRAM,
        discoverable: true,
        hideable: true,
        indexable: true,
        sortIndex: 2,
        validContentSortOrders: [
            {
                name: 'engagement_rate',
                displayName: 'Engagement Rate'
            },
            {
                name: 'engagement_total',
                displayName: 'Engagement Total'
            },
            {
                name: 'published_at',
                displayName: 'Date',
                skipAverage: true
            },
            {
                name: 'likes',
                displayName: 'Likes'
            },
            {
                name: 'comments',
                displayName: 'Comments'
            },
            {
                name: 'applause',
                displayName: 'Likes',
                filter: true
            },
            {
                name: 'conversation',
                displayName: 'Comments',
                filter: true
            },
            {
                name: 'estimated_impressions',
                displayName: 'Estimated Impressions'
            },
            {
                name: 'engagement_rate_by_estimated_impression',
                displayName: 'Engagement Rate by Estimated Impression',
                skipAverage: true // NOTE no db column for this on this channel, so don't try to calculate over it
            }
        ],
        palette: [
            'x-instagram',
            'x-instagram-secondary'
        ]
    };

    enums.sourceDetails[enums.sources.INSTAGRAM_INSIGHTS] = enums.sourceDetails[sourceMask.INSTAGRAM_INSIGHTS] = _.defaults({
        discoverable: false,
        hideable: false,
        privateData: true,
        indexable: false,
        credentialsRequired: true,
        iconSvg: '/images/channel-instagram-lock.svg',
        name: 'Instagram Insights',
        companyFilter: createPrivateDataCompanyFilter(enums.sources.INSTAGRAM_INSIGHTS),
        source: enums.sources.INSTAGRAM_INSIGHTS,
        sourceMask: enums.sourceMask.INSTAGRAM_INSIGHTS,
        oauthTokenTypeId: 1, // these two lines are intentional - instagram insights data comes from the Facebook api.
        oauthKey: 'facebook',
        trendKey: 'instagramInsightsTrends',
        supportsNotEnoughHistory: true
    }, enums.sourceDetails[enums.sources.INSTAGRAM]);

    enums.sourceDetails[enums.sources.WEB] = enums.sourceDetails[sourceMask.WEB] = {
        iconUrl: '/images/globe.png',
        fontIcon: 'fa-globe',
        squareFontIcon: 'fa-globe',
        iconSvg: '/images/channel-website.svg',
        name: 'Website',
        channelName: 'SEO',
        source: enums.sources.WEB,
        sourceMask: enums.sourceMask.WEB,
        channel: enums.channels.WEB,
        channelPrefix: 'url',
        group: 'none',
        hideableSource: enums.hideableSource.WEB,
        trendKey: 'urlExtractedDataTrends',
        sortIndex: 9,
        validContentSortOrders: []
    };

    enums.sourceDetails[enums.sources.RIVALIQ] = {
        iconUrl: '/images/logo.png',
        dontShowInUi: true,
        name: 'Rival IQ',
        source: enums.sources.RIVALIQ,
        channel: enums.channels.RIVALIQ,
        validContentSortOrders: []
    };

    enums.sourceDetails[enums.sources.TIKTOK] = enums.sourceDetails[sourceMask.TIKTOK] = {
        dontShowInUi: false,
        iconUrl: '/images/icon-tiktok.png',
        fontIcon: 'fab fa-tiktok',
        squareFontIcon: 'fab fa-tiktok', // TODO: there is no square tiktok icon in font-awesome
        iconSvg: '/images/channel-tiktok.svg',
        name: 'TikTok',
        source: enums.sources.TIKTOK,
        sourceMask: enums.sourceMask.TIKTOK,
        channel: enums.channels.TIKTOK,
        channelPrefix: 'tiktok',
        multiOauthToken: true,
        uniqueKeyPart: 'open_id',
        oauthTokenTypeId: 10,
        oauthKey: 'tiktok',
        channelWallImage: '/images/tiktok-auth.svg',
        trendKey: 'tiktokTrends',
        searchUrl: 'https://www.tiktok.com/search/people/?q=',
        profileUrl: 'https://www.tiktok.com/',
        identityType: 'handle',
        supportsNotEnoughHistory: true,
        identityValueFields: ['native_id', 'handle', 'secuid'],
        reachName: 'Followers',
        engagementTypeMappings: [
            {
                name: 'digg_count',
                displayName: 'Likes'
            },
            {
                name: 'comment_count',
                displayName: 'Comments'
            },
            {
                name: 'share_count',
                displayName: 'Shares'
            },
            {
                name: 'play_count',
                displayName: 'Plays'
            }
        ],
        engagementTypes: [
            'applause',
            'conversation',
            'amplification'
        ],
        postName: 'video',
        group: 'social',
        hideableSource: enums.hideableSource.TIKTOK,
        discoverable: true,
        hideable: true,
        indexable: true,
        sortIndex: 7,
        engagementTypeNames: {
            applause: 'diggs',
            conversation: 'comments',
            amplification: 'shares'
        },
        validContentSortOrders: [
            {
                name: 'engagement_rate',
                displayName: 'Engagement Rate'
            },
            {
                name: 'engagement_total',
                displayName: 'Engagement Total'
            },
            {
                name: 'published_at',
                displayName: 'Date',
                skipAverage: true
            },
            {
                name: 'play_count',
                displayName: 'Plays'
            },
            {
                name: 'comment_count',
                displayName: 'Comments'
            },
            {
                name: 'share_count',
                displayName: 'Shares'
            },
            {
                name: 'applause',
                displayName: 'Likes',
                filter: true
            },
            {
                name: 'conversation',
                displayName: 'Comments',
                filter: true
            },
            {
                name: 'amplification',
                displayName: 'Shares',
                filter: true
            },
            {
                name: 'estimated_impressions',
                displayName: 'Estimated Impressions',
                skipAverage: true // NOTE no db column for this on this channel, so don't try to calculate over it; see #33520
            },
            {
                name: 'engagement_rate_by_estimated_impression',
                displayName: 'Engagement Rate by Estimated Impression',
                skipAverage: true // NOTE no db column for this on this channel, so don't try to calculate over it
            }
        ],
        palette: [
            'x-tiktok',
            'x-tiktok-secondary',
            'x-tiktok-tertiary'
        ]
    };

    enums.sourceDetails[enums.sources.TIKTOK_INSIGHTS] = enums.sourceDetails[sourceMask.TIKTOK_INSIGHTS] = _.defaults({
        discoverable: false,
        hideable: false,
        privateData: true,
        indexable: false,
        credentialsRequired: true,
        iconSvg: '/images/channel-tiktok-lock.svg',
        name: 'TikTok Insights',
        companyFilter: createPrivateDataCompanyFilter(enums.sources.TIKTOK_INSIGHTS),
        source: enums.sources.TIKTOK_INSIGHTS,
        sourceMask: enums.sourceMask.TIKTOK_INSIGHTS,
        trendKey: 'tiktokInsightsTrends',
        supportsNotEnoughHistory: true,
        privateDataLoadingImage: '/images/tiktok-insights-loading.gif'
    }, enums.sourceDetails[enums.sources.TIKTOK]);

    enums.sourceDetails[enums.sources.CROSS_CHANNEL_INSIGHTS] = enums.sourceDetails[sourceMask.CROSS_CHANNEL_INSIGHTS] = {
        discoverable: false,
        hideable: false,
        privateData: true,
        indexable: false,
        name: 'Cross-Channel Insights',
        channel: enums.channels.CROSS_CHANNEL_INSIGHTS,
        source: enums.sources.CROSS_CHANNEL_INSIGHTS,
        sourceMask: enums.sourceMask.CROSS_CHANNEL_INSIGHTS,
        fontIcon: 'fa-random',
        squareFontIcon: 'fa-random',
        iconSvg: '/images/channel-cross-channel.svg',
        reachName: 'Followers',
        postName: 'post',
        trendKey: 'metaTrends',
        supportsNotEnoughHistory: true,
        dontShowInUi: true,
        subSources: [
            enums.sources.FACEBOOK_INSIGHTS,
            enums.sources.INSTAGRAM_INSIGHTS,
            enums.sources.TWITTER_INSIGHTS,
            enums.sources.LINKEDIN,
            enums.sources.TIKTOK_INSIGHTS,
            ...enums.sourceDetails[enums.sources.CROSS_CHANNEL].subSources
        ]
    };

    enums.hideableSourceDescriptions = {};
    enums.hideableSourceDescriptions[enums.hideableSource.FACEBOOK] = {
        name: enums.sourceDetails[enums.sourceMask.FACEBOOK].name,
        fontIcon: enums.sourceDetails[enums.sourceMask.FACEBOOK].fontIcon
    };

    enums.hideableSourceDescriptions[enums.hideableSource.INSTAGRAM] = {
        name: enums.sourceDetails[enums.sourceMask.INSTAGRAM].name,
        fontIcon: enums.sourceDetails[enums.sourceMask.INSTAGRAM].fontIcon
    };

    enums.hideableSourceDescriptions[enums.hideableSource.TWITTER] = {
        name: enums.sourceDetails[enums.sourceMask.TWITTER].name,
        fontIcon: enums.sourceDetails[enums.sourceMask.TWITTER].fontIcon
    };

    enums.hideableSourceDescriptions[enums.hideableSource.YOUTUBE] = {
        name: enums.sourceDetails[enums.sourceMask.YOUTUBE].name,
        fontIcon: enums.sourceDetails[enums.sourceMask.YOUTUBE].fontIcon
    };

    enums.hideableSourceDescriptions[enums.hideableSource.TIKTOK] = {
        name: enums.sourceDetails[enums.sourceMask.TIKTOK].name,
        fontIcon: enums.sourceDetails[enums.sourceMask.TIKTOK].fontIcon
    };

    _.each(enums.hideableSourceDescriptions, function (description, source) {
        const sourceDetails = _.filter(enums.sourceDetails, {
            hideableSource: source
        });

        description.mask = _.reduce(_.map(sourceDetails, 'sourceMask'), function (result, mask) {
            return result | mask;
        }, 0);
    });

})(RivalIQ.enums);
